import { useTranslation } from 'react-i18next';

import { type Card, useSetCardDeadline } from '@/entities/board';
import { useViewer } from '@/entities/viewer';
import { FormError } from '@/shared/forms';
import { Dialog, DeadlineForm } from '@/shared/ui';

interface Props {
  card: Card;
  onClose: () => void;
}

/**
 * Compact editor opened from a tile's deadline badge: changes ONLY the deadline (start, end,
 * date/time, remove) without opening the whole card dialog.
 */
export function QuickDeadlineDialog({ card, onClose }: Props) {
  const { t } = useTranslation();
  const setDeadline = useSetCardDeadline();
  const viewer = useViewer();
  const zone = viewer.status === 'authenticated' ? viewer.user.timezone : null;

  return (
    <Dialog title={t('deadline.quickTitle', { title: card.title })} onClose={onClose}>
      <DeadlineForm
        initial={card.deadline}
        timezone={zone}
        pending={setDeadline.isPending}
        error={<FormError error={setDeadline.error} />}
        onSave={(payload) => {
          setDeadline.mutate({ cardId: card.id, deadline: payload }, { onSuccess: onClose });
        }}
        onRemove={
          card.deadline
            ? () => {
                setDeadline.mutate({ cardId: card.id, deadline: null }, { onSuccess: onClose });
              }
            : undefined
        }
        onCancel={onClose}
      />
    </Dialog>
  );
}
